var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HomePage"},[_c('el-container',[_c('Header',{ref:"header"}),_c('el-main',{style:('min-height:' + _vm.mainHeight + 'px')},[_c('router-view')],1),_c('el-footer',[_c('Footer',{ref:"footer"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }